import api from "../plugins/apiWrapper";

const DEFAULT_NETWORK = process.env.VUE_APP_DEFAULT_NETWORK || "mumbai";

export default {
  // USERS
  async fetchMe() {
    return api.get(`/users/me`);
  },

  async fetchUsers() {
    return api.get(`/users`);
  },

  async fetchUser(id) {
    return api.get(`/users/${id}`);
  },

  async updateUser(userData, id) {
    return api.put(`/users/${id}`, userData);
  },

  async fetchNonce(publicAddress) {
    return api.get(`/getnonce/${publicAddress}`);
  },

  async verifyNonce(publicAddress, signature) {
    return api.post("/verify-cardano", { publicAddress, signature });
  },

  async signup(publicAddress) {
    return api.post("/signup", { publicAddress });
  },

  async signupCardano(publicAddress) {
    return api.post("cardano/signup", { publicAddress });
  },

  async disconnect() {
    return api.post("/disconnect");
  },

  //NFTS
  async pinFile(formData) {
    return api.post("/nfts/pin-file", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async fetchNftList(queryParams) {
    const params = Object.fromEntries(new URLSearchParams(queryParams));
    return api.get("/nfts", {
      params: Object.assign(params, { network: DEFAULT_NETWORK }),
    });
  },

  async fetchExternalNftList({ id, page }) {
    return api.get(`/users/${id}/non-theos-nfts?page=${page}`);
  },

  async storeNft(nftData) {
    return api.post(
      "/nfts",
      Object.assign(nftData, { network: DEFAULT_NETWORK })
    );
  },

  async updateNft(id, nftData) {
    return api.put(`/nfts/${id}`, nftData);
  },

  async deleteNft(id) {
    return api.delete(`/nfts/${id}`);
  },

  async storeNftFile(formData) {
    return api.post("/file-uploads/nft", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },
  async fetchNft(id) {
    return api.get(`/nfts/${id}`);
  },

  async storeCoverImageFile(formData) {
    return api.post("/file-uploads/cover-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async autogenerateCoverImage(formData) {
    return api.post("/file-uploads/autogenerate-cover", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  async storeUserProfileImageFile(formData) {
    return api.post("/file-uploads/user-profile-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  // POOLS
  async fetchPools(params) {
    return api.get(`/pools?${params}`);
  },

  // Blockfrost
  async cardanoProtocolParameters() {
    return api.get("blockfrost/parameters");
  },
  async cardanoLatestBlock() {
    return api.get("blockfrost/blocks/latest");
  },
  async cardanoSubmitTx(data) {
    return api.post("blockfrost/submit", data, {
      headers: {
        "Content-Type": "application/octet-stream",
      },
    });
  },
};
